import React from "react";
import InputFieldComponent from "./../../components/InputFieldComponent";
import { Col, Button, Image } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const EditHeadComponent = ({
	settingTitle,
	goTobutton,
	buttonTitle,
	settingDescription,
	backToprofileView,
	profileStatus,
	isBorder = true,
}) => {
	return (
		<div className="tutor-setting-BioAndSub">
			<div className="back-link" onClick={backToprofileView}>
				<img src={require("./../../assets/icons/back-left.png")}/>Back To editing profile
			</div>
			<div
				className="EditHead-bio-and-sub-col flex-between-center"
				style={{ borderBottom: isBorder ? "1px solid #ccc" : "" }}
			>
				<div>
					<h4 className="title">{settingTitle}</h4>
					{ settingDescription ? (
						<p className="subtitle" style={{ margin: profileStatus ? "16px 0 27px 0" : "" }}>
							{ 
								profileStatus ? (
									<span>
										<img
											src={ profileStatus === "Live"
												? require("./../../assets/icons/greenCircle.svg")
												: require("./../../assets/icons/away.png")
											}
										/>
										{`${profileStatus} - `}
									</span>
								) : ""
							}
							{settingDescription}
						</p>
					) : "" }
				</div>
				{ 
					buttonTitle ? (
						<Button
							className="green-unfill-btn"
							onClick={goTobutton}
							style={{
							border: "none",
							fontSize: "16px",
							fontFamily: "CircularStdMedium, Arial, sans-serif",
							}}
						>
							{buttonTitle}
						</Button>
					) : "" 
				}
			</div>
		</div>
	);
};

export const EducationAndWorkPanel = ({
  head,
  value,
  onEdit,
  mode,
  selectedIndex,
  index,
}) => {
  return (
    <div
      style={{
        paddingBottom: "30px",
        marginBottom: "50px",
        borderBottom: "1px solid #ccc",
      }}
    >
      <div className="flex-between-center">
        {mode ? (
          <div
            style={{ fontSize: "16px", fontWeight: "600", color: "#0f0f0f" }}
          >
            School / University / Other institution
          </div>
        ) : (
          ""
        )}
        {mode ? (
          <Button
            className="green-unfill-btn flex-center-center"
            style={{
              width: "66px",
              height: "36px",
              borderRadius: "5px",
              border: "2px solid  #2cb46d",
              textAlign: "center",
              fontSize: "14px",
              fontWeight: "600",
              backgroundColor: "transparent",
            }}
            onClick={onEdit}
            disabled={selectedIndex === 0 || selectedIndex ? true : false}
          >
            Edit
          </Button>
        ) : (
          ""
        )}
      </div>
      <div>
        <div style={{ fontSize: "16px", color: "#0f0f0f" }} className="flex-between-center">
          {head ? head : ""}
          {!mode ? (
          <Button
            className="green-unfill-btn flex-center-center"
            style={{
              width: "66px",
              height: "36px",
              borderRadius: "5px",
              border: "2px solid  #2cb46d",
              textAlign: "center",
              fontSize: "14px",
              fontWeight: "600",
              backgroundColor: "transparent",
            }}
            onClick={onEdit}
            disabled={selectedIndex === 0 || selectedIndex ? true : false}
          >
            Edit
          </Button>
        ) : (
          ""
        )}
        </div>
        <div style={{ fontSize: "14px", color: "#0f0f0f" }}>
          {value ? value : ""}
        </div>
      </div>
    </div>
  );
};

export const EditEducationAndWorkPanel = ({
  EditSpecificEduAndWork,
  firstInputName,
  secondInputName,
  secondInputHeadTitle,
  thirdInputHeadTitle,
  thirdInputName,
  firstInputHeadTitle,
  current,
  index,
  onTextChange,
  onCurrent,
  onCancel,
  onChangeDate,
  roleText,
  style,
  Addbtn,
  onSave,
  onRemove,
  AddObj,
  ismodal,
  firstInputReq,
  secondInputReq,
  firstInputError,
  secondInputError,
  startDateReq,
  endDateReq,
}) => {
  return (
    <div>
      <InputFieldComponent
        InputHeadTitle={firstInputHeadTitle}
        style={{
          height: style?.height ? style.height : "60px",
          headTitle: {
            fontSize: style?.head?.fontSize ? style?.head?.fontSize : "18px",
            marginBottom: "15px",
            fontWeight: style?.head?.fontWeight
              ? style?.head?.fontWeight
              : "500",
            fontFamily: "CircularStd",
          },
          border: "none",
          UnderStyleP: {
            marginBottom: "5px",
          },
          borderGroup:
            firstInputReq && !EditSpecificEduAndWork?.[firstInputName]
              ? "1px solid #fa4a4a"
              : null,
          backgroundColor:
            firstInputReq && !EditSpecificEduAndWork?.[firstInputName]
              ? "#fff1f1"
              : null,
        }}
        name={firstInputName}
        value={EditSpecificEduAndWork?.[firstInputName]}
        onChange={(e) => onTextChange(e, index)}
        headBtn={!Addbtn ? "Cancel" : ""}
        onHeadBtn={onCancel}
      />
      {firstInputReq && !EditSpecificEduAndWork?.[firstInputName] ? (
        <div
          style={{
            color: "#fa4a4a",
            fontSize: "12px",
            marginBottom: "5px",
            fontFamily: "OpenSans, Arial, sans-serif",
          }}
          className="flex-start-center"
        >
          <Image
            src={require("./../../assets/icons/info.png")}
            style={{ marginRight: "10px" }}
          />
          {firstInputError}
        </div>
      ) : (
        ""
      )}
      <div style={{ marginBottom: style?.head ? "20px" : "50px" }} />
      <InputFieldComponent
        InputHeadTitle={secondInputHeadTitle}
        value={EditSpecificEduAndWork?.[secondInputName]}
        // placeholder="Qulification"
        name={secondInputName}
        style={{
          height: style?.height ? style.height : "60px",
          headTitle: {
            fontSize: style?.head?.fontSize ? style?.head?.fontSize : "18px",
            marginBottom: "15px",
            fontWeight: style?.head?.fontWeight
              ? style?.head?.fontWeight
              : "500",
            fontFamily: "CircularStd",
          },
          border: "none",
          UnderStyleP: {
            marginBottom: "5px",
          },
          borderGroup:
            secondInputReq && !EditSpecificEduAndWork?.[secondInputName]
              ? "1px solid #fa4a4a"
              : null,
          backgroundColor:
            secondInputReq && !EditSpecificEduAndWork?.[secondInputName]
              ? "#fff1f1"
              : null,
        }}
        onChange={(e) => onTextChange(e, index)}
      />
      {secondInputReq && !EditSpecificEduAndWork?.[secondInputName] ? (
        <div
          style={{
            color: "#fa4a4a",
            fontSize: "12px",
            marginBottom: "5px",
            fontFamily: "OpenSans, Arial, sans-serif",
          }}
          className="flex-start-center"
        >
          <Image
            src={require("./../../assets/icons/info.png")}
            style={{ marginRight: "10px" }}
          />
          {secondInputError}
        </div>
      ) : (
        ""
      )}
      <div style={{ marginBottom: "20px" }} />
      <div className="custom-control custom-checkbox">
        <input
          type="checkbox"
          className="custom-control-input"
          id={`customCheck2${index}`}
          checked={EditSpecificEduAndWork?.[current]}
        />
        <label
          className="custom-control-label enroll"
          htmlFor={`customCheck2${index}`}
          style={{ cursor: "pointer" }}
          onClick={() => onCurrent(index, current)}
        >
          <p style={{ fontSize: "14px", fontWeight: "600" }}>{roleText}</p>
        </label>
      </div>
      <div style={{ marginBottom: "20px" }} />
      <div className="flex date-picker-inEdu">
        <Col style={{ flex: "1", paddingLeft: "0px" }}>
          <div
            style={{
              color: "rgb(0, 0, 0)",
              marginBottom: "15px",
              fontSize: style?.head?.fontSize ? style?.head?.fontSize : "18px",
              fontFamily: "CircularStd",
              marginBottom: "15px",
              fontWeight: style?.head?.fontWeight
                ? style?.head?.fontWeight
                : "500",
            }}
          >
            Start Date
          </div>
          <div
            className={`${
              !EditSpecificEduAndWork.startDate && startDateReq
                ? "dateValidate-show"
                : ""
            }`}
          >
            <DatePicker
              selected={
                EditSpecificEduAndWork?.startDate
                  ? new Date(
                      new Date(EditSpecificEduAndWork.startDate).getTime()
                    )
                  : null
              }
              onChange={(date) => onChangeDate(date, index, "startDate")}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              showFullMonthYearPicker
              placeholderText="MM/YYYY"
              className={ismodal ? "custome-new" : ""}
            />
            {(!EditSpecificEduAndWork.startDate && startDateReq) ||
            (!EditSpecificEduAndWork?.[current] &&
              !EditSpecificEduAndWork?.endDate &&
              endDateReq) ? (
              <div
                style={{
                  color: "#fa4a4a",
                  fontSize: "12px",
                  marginBottom: "5px",
                  fontFamily: "OpenSans, Arial, sans-serif",
                }}
                className="flex-start-center"
              >
                <Image
                  src={require("./../../assets/icons/info.png")}
                  style={{ marginRight: "10px" }}
                />
                Add start and end date
              </div>
            ) : (
              ""
            )}
          </div>
        </Col>
        {!EditSpecificEduAndWork?.[current] ? (
          <Col style={{ flex: "1", paddingRight: "0px" }}>
            <div
              style={{
                color: "rgb(0, 0, 0)",
                marginBottom: "15px",
                fontSize: style?.head?.fontSize
                  ? style?.head?.fontSize
                  : "18px",
                fontFamily: "CircularStd",
                marginBottom: "15px",
                fontWeight: style?.head?.fontWeight
                  ? style?.head?.fontWeight
                  : "500",
              }}
            >
              End Date
            </div>
            <div
              className={`${
                !EditSpecificEduAndWork.endDate && endDateReq
                  ? "dateValidate-show"
                  : ""
              }`}
            >
              <DatePicker
                selected={
                  EditSpecificEduAndWork?.endDate
                    ? new Date(
                        new Date(EditSpecificEduAndWork.endDate).getTime()
                      )
                    : null
                }
                onChange={(date) => onChangeDate(date, index, "endDate")}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                showFullMonthYearPicker
                placeholderText="MM/YYYY"
                className={ismodal ? "custome-new" : ""}
              />
            </div>
          </Col>
        ) : (
          <Col style={{ flex: "1", paddingRight: "0px" }}></Col>
        )}
      </div>
      <div style={{ marginBottom: style?.head ? "20px" : "50px" }} />
      {/* <InputFieldComponent
        InputHeadTitle={thirdInputHeadTitle}
        value={EditSpecificEduAndWork?.[thirdInputName]}
        name={thirdInputName}
        style={{
          height: style?.height ? style.height : "60px",
          headTitle: {
           fontSize:style?.head?.fontSize ? style?.head?.fontSize : "18px", 
            marginBottom: "15px",
            fontWeight: style?.head?.fontWeight
              ? style?.head?.fontWeight
              : "500",
            fontFamily: "CircularStd"
          },
          border: "none",
        }}
        onChange={(e) => onTextChange(e, index)}
      /> */}
      {Addbtn ? (
        <Col lg={10} md={10} sm={12} xs={12} style={{ padding: "0px" }}>
          <Button
            className="green-Button"
            style={{
              fontSize: "16px",
              marginTop: "25px",
              width: "126px",
              height: "45px",
              borderRadius: "5px",
              backgroundColor: "#2cb46d",
            }}
            onClick={AddObj}
            disabled={
              !EditSpecificEduAndWork?.[firstInputName] ||
              !EditSpecificEduAndWork?.[secondInputName] ||
              !EditSpecificEduAndWork?.startDate ||
              (!EditSpecificEduAndWork?.[current] &&
                !EditSpecificEduAndWork?.endDate)
            }
          >
            {Addbtn}
          </Button>
        </Col>
      ) : (
        <Col lg={10} md={10} sm={12} xs={12} style={{ padding: "0px" }}>
          <Button
            className="green-Button"
            style={{
              fontSize: "16px",
              marginTop: "25px",
              width: "126px",
              height: "45px",
              borderRadius: "5px",
              backgroundColor: "#2cb46d",
            }}
            onClick={() => onSave(index)}
            disabled={
              !EditSpecificEduAndWork?.[firstInputName] ||
              !EditSpecificEduAndWork?.[secondInputName] ||
              !EditSpecificEduAndWork?.startDate ||
              (!EditSpecificEduAndWork?.[current] &&
                !EditSpecificEduAndWork?.endDate)
            }
          >
            Save
          </Button>
          <Button
            className="green-unfill-btn"
            style={{
              fontSize: "16px",
              marginTop: "25px",
              width: "126px",
              height: "45px",
              borderRadius: "5px",
              marginTop: "25px",
              marginLeft: "20px",
            }}
            onClick={() => onRemove(index)}
          >
            Remove
          </Button>
          <div style={{ marginBottom: "50px" }} />
          <hr />
        </Col>
      )}
    </div>
  );
};
